import ENUMS from "../utils/ENUMS";
import axios from "axios";
import HttpService from "../services/HttpService";

import {BASE_URL} from '../config.json'

export const API_URL = `${BASE_URL}`;
const token = localStorage.getItem(ENUMS.AUTH);


export const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
    },
});

export const api2 = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        Authorization:
            "Bearer " + token
    },
});


export default class ApiService {

    static checkEmailIsRegistered(value) {
        const payload = {
            "email": value
        }
        return api.post(`${API_URL}/user/check_email/`, payload)
    }

    static checkClubRegistered(gname) {
        // const payload = {
        //   "email" : value
        // }
        return api.get(`${API_URL}/club/check_club/${gname}/`)
    }

    static saveStripeInfo(data = {}) {
        console.log(data);
        // return api.post(`${API_URL}/payments/save-stripe-info/`, data)
        let Create_ClubDetail_val = JSON.parse(
            localStorage.getItem("Create-ClubDetail")
        );
        let Create_GolfCourse_val = JSON.parse(
            localStorage.getItem("Create-GolfCourse")
        );
        let arrOfGolfCourseInfo = [];
        Create_GolfCourse_val.forEach((arrayItem, idx) => {
            // var x = arrayItem.prop1 + 2;
            // console.log(x);
            arrOfGolfCourseInfo.push({
                course_number: idx + 1,
                course_name: arrayItem.course_name,
                golfcourseholes: parseInt(arrayItem.number_of_holes == '9' ? '1' : '2'),
                latitude: null,
                longitude: null,
            });
        });

        let api_posting = {
            club_details: {
                first_name: Create_ClubDetail_val.name,
                last_name: " ",
                email: Create_ClubDetail_val.email,
                password: Create_ClubDetail_val.psw_2,
                golfclub: Create_ClubDetail_val.gname,
                phone_number: Create_ClubDetail_val.phone,
                website_url: Create_ClubDetail_val.website,
                address: {
                    address1: Create_ClubDetail_val.address,
                    address2: Create_ClubDetail_val.address2,
                    town: Create_ClubDetail_val.town,
                    county: Create_ClubDetail_val.county,
                    country: Create_ClubDetail_val.country,
                    post_code: Create_ClubDetail_val.postcode,
                },
            },
            golf_courses: arrOfGolfCourseInfo,
            payment_details: {
                subscription_id: data.subscription_id,
                payment_method_id: data.payment_method_id,
            },
        };


        return HttpService.post(`/club/create/`, api_posting)
        .then((response) => {
            console.log("API Response:", response);
            if (response?.data) {
                localStorage.setItem("stripe_payment_method_id", data.payment_method_id);
                localStorage.setItem("stripe_transaction_id", response.data.data.stripe_transaction_id);
            }
            return response;
        })
        .catch((error) => {
            console.error("API Error:", error);
            throw error;
        });
    }

    static saveRenewStripeInfo(data = {}) {
        console.log(data);
        return api2.post(`${BASE_URL}/club/subscrption/`, data);

    }

    static changeStripePaymentMethod(data) {
        let api_posting = {
            "payment_method_id": data.payment_method_id,
        };
        return api2.put("/club/payment_method/change/", api_posting);
    }

    static fetchCardNo() {
        const card = api2.get(`${API_URL}/payments/payment_details/`).then(({data}) => {
            return data.data.card;
        })
        return card;
    }

    static getSubscriptionDetails() {
        return api.get(`${API_URL}/get_subscription/`)
    }
}
